// NewMemberByEmailFields.js
import React from 'react';
import { generateTextField } from '../../../b2b-common/helpers';

const NewMemberByEmailFields = ({ member, handleFieldChange }) => {
    return (
        <div className='new-member-by-email-fields-container'>
            {generateTextField("Email", member.user.email, "membership-info-textfield", false, (e) => handleFieldChange('email', e.target.value), { required: true })}
        </div>
    );
};

export default NewMemberByEmailFields;
